<template>
  <div id="outer_area"
    class="d-flex align-items-center justify-content-center"
    @click.self="clickedOuterArea()"
    @dragover.prevent>
    <div class="drop_area d-flex align-items-center justify-content-center"
      :class="{'enter': bEnterDropArea}"
      @dragenter="eDragEnter()"
      @dragleave="eDragLeave()"
      @dragover.prevent
      @drop.prevent="eDropFile">
      <button class="btn btn-primary" @click='eClickedImportButton()' @dragenter="eDragEnter()">{{notes}}</button>
      <input @change="eChangedFile" ref="tagButton" id="file_read" style="display: none;" accept="strAccept" type="file" />
    </div>
  </div>
</template>

<script lang="ts">
import { ref, toRef, defineComponent } from 'vue'

export default defineComponent({
  props: {
    accept: {
      default: ''
    },
    fileInfo: {
      default: 0
    },
    notes: {
      default: 'ファイルを選択'
    }
  },
  setup (props, context) {
    const strAccept = toRef(props, 'accept')
    const intFileInfo = toRef(props, 'fileInfo')
    const tagButton = ref()
    const bEnterDropArea = ref(false)

    const eDragEnter = () => {
      bEnterDropArea.value = true
    }

    const eDragLeave = () => {
      bEnterDropArea.value = false
    }

    const eClickedImportButton = () => {
      tagButton.value.click()
    }

    const eChangedFile = (e) => {
      const files = e.target.files
      fnImportFileData(files)
      bEnterDropArea.value = false
    }

    const eDropFile = (e) => {
      const files = e.dataTransfer.files
      bEnterDropArea.value = false
      fnImportFileData(files)
    }

    const clickedOuterArea = () => {
      context.emit('modalClose')
    }

    const fnImportFileData = (files) => {
      if (files !== null && files.length > 0) {
        context.emit('uploadFile', { file: files[0], fileInfo: intFileInfo.value })
      }
    }
    return {
      strAccept,
      bEnterDropArea,
      tagButton,
      eDragEnter,
      eDragLeave,
      eClickedImportButton,
      eChangedFile,
      eDropFile,
      clickedOuterArea
    }
  }
})
</script>

<style lang="scss" scoped>
#outer_area {
  position: relative;
  width: 100%;
  height: 100%;
  .drop_area {
    align-items: center;
    border-radius: 6px;
    padding: 20px 24px 20px 24px;
    margin: 0 auto;
    vertical-align: middle;
    z-index: 2;
  }
}
.enter {
  border: 10px dotted powderblue;
}
</style>
